import { Alert } from '@mgmresorts/mgm-ui';
import React, { useContext } from 'react';

import { Container } from '../../../components/ui/Container';
import { Logo } from '../../../components/ui/Logo';
import { useContent } from '../../../hooks/useContent';

import { BirthdayInput } from './BirthdayInput';
import { CTASection } from './CTASection';
import { CanadianOptIn } from './CanadianOptIn';
import { EmailInput } from './EmailInput';
import { FirstName } from './FirstName';
import { LastName } from './LastName';
import { ManualAddressForm } from './ManualAddressForm';
import { MlifeAccountSetupContext } from './MlifeAccountSetupContext';
import { PasswordInput } from './PasswordInput';
import { PhoneNumberInput } from './PhoneNumberInput';
import { PolicyCheckbox } from './PolicyCheckbox';
import {
  StyledAddressSubTitle,
  StyledAlertContainer,
  StyledHeading,
  StyledInfo,
  StyledInputContainer,
  StyledSubTitle,
} from './styles';

export function MlifeAccountSetupForm() {
  const { accountSetupError } = useContext(MlifeAccountSetupContext);
  const { getContentByPath } = useContent();

  return (
    <Container height='auto'>
      <Logo />
      <StyledHeading variant='body-medium-l' as='h1' testId='page-title'>
        {getContentByPath('mlifeActivation.accountSetupSection.title')}
      </StyledHeading>
      <StyledInfo variant='body-regular-m'>
        {getContentByPath('mlifeActivation.accountSetupSection.subtitle')}
      </StyledInfo>
      {accountSetupError && (
        <StyledAlertContainer>
          <Alert variant='error' open message={accountSetupError} hiddenCloseButton />
        </StyledAlertContainer>
      )}
      <StyledInputContainer>
        <EmailInput />
      </StyledInputContainer>
      <StyledInputContainer>
        <PasswordInput />
      </StyledInputContainer>
      <div>
        <StyledSubTitle variant='body-medium-l' as='h2' className='identity__guestInfo-title' testId='page-sub-title'>
          {getContentByPath('mlifeActivation.accountSetupSection.fields.guestInfo.title')}
        </StyledSubTitle>
        <StyledInputContainer>
          <FirstName />
        </StyledInputContainer>
        <StyledInputContainer>
          <LastName />
        </StyledInputContainer>
        <StyledInputContainer>
          <BirthdayInput />
        </StyledInputContainer>
        <StyledInputContainer>
          <PhoneNumberInput />
        </StyledInputContainer>
      </div>
      <div>
        <StyledAddressSubTitle
          variant='body-medium-l'
          as='h5'
          className='identity__guestInfo-title'
          testId='page-sub-title'
        >
          {getContentByPath('mlifeActivation.accountSetupSection.fields.address.title')}
        </StyledAddressSubTitle>
        <ManualAddressForm />
      </div>
      <CanadianOptIn />
      <PolicyCheckbox />
      <CTASection />
    </Container>
  );
}

MlifeAccountSetupForm.displayName = 'MlifeAccountSetupForm';
